<div class="mobile-register" *ngIf="isMobileApp">
  <div class="mr-status-spacer"></div>

  <button type="button" class="mr-back-btn" (click)="navigateToLogin()">
    <i class="bi bi-arrow-left"></i>
  </button>

  <h1>{{ 'REGISTER.TITLE' | translate }}</h1>
  <p class="subtitle">{{ 'REGISTER.SUBTITLE' | translate }}</p>

  <div class="mr-field-group">
    <label for="mr-name">{{ 'REGISTER.FULL_NAME_LABEL' | translate }}</label>
    <div class="mr-input-wrap">
      <input id="mr-name" type="text" class="mr-input" [(ngModel)]="nameValue"
        [placeholder]="'REGISTER.FULL_NAME_PLACEHOLDER' | translate" />
      <button *ngIf="nameValue" type="button" class="mr-clear-btn" (click)="clearField('name')">x</button>
    </div>
    <span *ngIf="nameError" class="mr-error">{{ nameError | translate }}</span>
  </div>

  <div class="mr-field-group">
    <label for="mr-email">{{ 'REGISTER.EMAIL_LABEL' | translate }}</label>
    <div class="mr-input-wrap">
      <input id="mr-email" type="email" class="mr-input" [(ngModel)]="emailValue"
        [placeholder]="'REGISTER.EMAIL_PLACEHOLDER' | translate" />
      <button *ngIf="emailValue" type="button" class="mr-clear-btn" (click)="clearField('email')">x</button>
    </div>
    <span *ngIf="emailError" class="mr-error">{{ emailError | translate }}</span>
  </div>

  <div class="mr-field-group">
    <label for="mr-mobile">{{ 'REGISTER.MOBILE_LABEL' | translate }}</label>
    <div class="mr-input-wrap">
      <input id="mr-mobile" type="tel" class="mr-input" [(ngModel)]="mobileValue"
        [placeholder]="'REGISTER.MOBILE_PLACEHOLDER' | translate" />
      <button *ngIf="mobileValue" type="button" class="mr-clear-btn" (click)="clearField('mobile')">x</button>
    </div>
    <span *ngIf="mobileError" class="mr-error">{{ mobileError | translate }}</span>
  </div>

  <div class="mr-field-group">
    <label for="mr-password">{{ 'REGISTER.PASSWORD_LABEL' | translate }}</label>
    <div class="mr-input-wrap">
      <input id="mr-password" [type]="showPassword ? 'text' : 'password'" class="mr-input" [(ngModel)]="passwordValue"
        placeholder="*************" />
      <button type="button" class="mr-eye-btn" (click)="togglePasswordVisibility()">
        <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
      </button>
      <button *ngIf="passwordValue" type="button" class="mr-clear-btn mr-clear-btn-password"
        (click)="clearField('password')">x</button>
    </div>
    <span *ngIf="passwordError" class="mr-error">{{ passwordError | translate }}</span>
  </div>

  <p class="mr-global-error" *ngIf="registerError">{{ registerError | translate }}</p>

  <button type="button" class="mr-signup-btn" (click)="validateAndSubmit()" [disabled]="isLoading">
    <span *ngIf="!isLoading">{{ 'REGISTER.SIGN_UP_BTN' | translate }}</span>
    <i *ngIf="isLoading" class="bi bi-arrow-repeat mr-spinner"></i>
  </button>

  <div class="mr-divider">
    <span class="line"></span>
    <span>{{ 'REGISTER.OR_SIGN_UP_WITH' | translate }}</span>
    <span class="line"></span>
  </div>

  <button type="button" class="mr-social-btn mr-google-btn" disabled>
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.7 15.9 19 12 24 12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z" />
      <path fill="#4CAF50"
        d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3c-2 1.5-4.5 2.5-7.3 2.5-5.2 0-9.7-3.3-11.2-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.1-3.4 5.5-6.6 6.8l.1.1 6.3 5.3c-.5.4 8.9-6.2 8.9-16.2 0-1.3-.1-2.4-.4-3.5z" />
    </svg>
    <span>{{ 'REGISTER.CONTINUE_GOOGLE' | translate }}</span>
  </button>

  <button type="button" class="mr-social-btn mr-apple-btn" disabled>
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor"
        d="M16.37 1.43c0 1.14-.41 2.2-1.11 2.96-.78.84-2.06 1.49-3.16 1.4-.14-1.08.42-2.2 1.12-2.92.77-.81 2.1-1.41 3.15-1.44zM20.9 17.23c-.58 1.32-.86 1.9-1.6 3.07-1.04 1.64-2.51 3.69-4.33 3.7-1.62.01-2.03-1.06-4.24-1.04-2.21.01-2.67 1.06-4.29 1.04-1.82-.01-3.21-1.86-4.25-3.49-2.9-4.54-3.2-9.87-1.41-12.6 1.28-1.95 3.3-3.09 5.2-3.09 1.94 0 3.16 1.06 4.76 1.06 1.55 0 2.5-1.06 4.74-1.06 1.69 0 3.49.92 4.77 2.51-4.17 2.33-3.49 8.36.65 9.9z" />
    </svg>
    <span>{{ 'REGISTER.CONTINUE_APPLE' | translate }}</span>
  </button>

  <p class="mr-footer">
    {{ 'REGISTER.HAVE_ACCOUNT' | translate }}
    <span class="mr-login-link" (click)="navigateToLogin()">{{ 'REGISTER.LOG_IN' | translate }}</span>
  </p>

  <div class="mr-home-indicator-spacer"></div>
</div>